var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "5px",
    viewBox: "0 0 7 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0752C669-6502-433B-B663-5D0023CDC178") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-+-Tech-Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S_Dashboard-tabs3-active",
    transform: "translate(-552.000000, -1123.000000)",
    fill: "#929AA6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clients-list",
    transform: "translate(0.000000, 833.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-+-filters",
    transform: "translate(390.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input",
    transform: "translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.690416,23 L142.559591,23 C142.351375,23 142.160393,23.1184216 142.063832,23.3068288 C141.967271,23.4955782 141.981094,23.7235277 142.09966,23.8983438 L144.730933,27.7797114 C144.824663,27.9182234 144.97908,28.0003637 145.143553,28 C145.308204,27.9992919 145.462131,27.9160342 145.555103,27.7771574 L148.15213,23.8957897 C148.26947,23.7202211 148.282201,23.4933434 148.185439,23.3052782 C148.088543,23.117669 147.898074,23 147.690416,23 Z",
    id: "icon-dropdownInput-Copy-10"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownIcon);
export default __webpack_public_path__ + "static/media/icon-dropdown-icon.c3636382ba6ffc7d927f602d113ee6e4.svg";
export { ForwardRef as ReactComponent };